(function () {
  const STORAGE_KEY = 'genderCategory';
  const DEFAULT = 'clothing';

  function getActive() {
    return localStorage.getItem(STORAGE_KEY) || DEFAULT;
  }

  function reinitSliders(container) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (window.Flickity) {
          container.querySelectorAll('.flickity-enabled').forEach(function (el) {
            var flkty = Flickity.data(el);
            if (flkty) { flkty.resize(); flkty.reposition(); }
          });
        }
        window.dispatchEvent(new Event('resize'));
      });
    });
  }

  function applyNav(category) {
    document.querySelectorAll('[data-gender-nav]').forEach(function (el) {
      var val = el.getAttribute('data-gender-nav');
      if (val === 'all' || val === category) {
        el.style.removeProperty('display');
      } else {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function applyCategory(category) {
    localStorage.setItem(STORAGE_KEY, category);
    document.documentElement.setAttribute('data-gender', category);
    applyNav(category); // ← THIS LINE WAS MISSING
    document.querySelectorAll('[data-gender-tab]').forEach(function (btn) {
      btn.setAttribute('aria-selected', btn.dataset.genderTab === category ? 'true' : 'false');
    });
    document.querySelectorAll('[data-gender-section="' + category + '"]').forEach(function (el) {
      reinitSliders(el);
    });
    document.dispatchEvent(new CustomEvent('genderChanged', { detail: { category: category } }));
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-gender-tab]');
    if (tab) applyCategory(tab.dataset.genderTab);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var category = getActive();
    document.documentElement.setAttribute('data-gender', category);
    applyNav(category);
    document.querySelectorAll('[data-gender-tab]').forEach(function (btn) {
      btn.setAttribute('aria-selected', btn.dataset.genderTab === category ? 'true' : 'false');
    });
    setTimeout(function () {
      document.querySelectorAll('[data-gender-section="' + category + '"]').forEach(function (el) {
        reinitSliders(el);
      });
    }, 300);
  });

  document.addEventListener('shopify:section:load', function () {
    var category = getActive();
    document.documentElement.setAttribute('data-gender', category);
    applyNav(category);
  });

})();
document.addEventListener('DOMContentLoaded', function () {

  // when their row is clicked.
  function hasRealLink(link) {
    const href = (link.getAttribute('href') || '').trim();
    return href !== '' && href !== '#' && href.indexOf('javascript') !== 0;
  }

  function initAccordion() {

    // ── LEVEL 1: Top-level items (NEW IN, JEWELLERY, SHOP BY ITEM, etc.)
    const level1Items = document.querySelectorAll(
      '.sr4-mb-menu > ul > li.sr4-menu-item-has-children'
    );

    level1Items.forEach(function (item) {
      const link = item.querySelector(':scope > a');
      if (!link) return;

      link.addEventListener('click', function (e) {
        const subMenu = item.querySelector(':scope > .sr4-sub-menu');
        if (!subMenu) return;
        // dropdown icon, let the browser follow the link.
        const clickedIcon = e.target.closest('.sr4-mb-nav__icon');
        if (hasRealLink(link) && !clickedIcon) return;

        e.preventDefault();
        e.stopPropagation();

        const isOpen = item.classList.contains('is--opend');

        // Close all other level-1 siblings
        level1Items.forEach(function (sibling) {
          if (sibling !== item) {
            sibling.classList.remove('is--opend');
            const sibSub = sibling.querySelector(':scope > .sr4-sub-menu');
            if (sibSub) sibSub.style.display = 'none';
          }
        });

        // Toggle clicked level-1 item
        item.classList.toggle('is--opend', !isOpen);
        subMenu.style.display = isOpen ? 'none' : 'block';
      });
    });

    // ── LEVEL 2: Child items inside sub-menu (Sets, Earrings, etc.)
    const level2Items = document.querySelectorAll(
      '.sr4-sub-menu .sr4-menu-item-has-children'
    );

    level2Items.forEach(function (item) {
      const link = item.querySelector(':scope > a');
      if (!link) return;

      link.addEventListener('click', function (e) {
        const subSubMenu = item.querySelector(':scope > .sr4-sub-sub-menu');
        if (!subSubMenu) return;
      
        // Only the dropdown icon toggles the sub-menu.
        const clickedIcon = e.target.closest('.sr4-mb-nav__icon');
        if (hasRealLink(link) && !clickedIcon) return;
        e.preventDefault();
        e.stopPropagation(); // prevent triggering level-1 click

        const isOpen = item.classList.contains('is--opend');

        // Close all other level-2 siblings
        const parentSubMenu = item.closest('.sr4-sub-menu');
        parentSubMenu.querySelectorAll('.sr4-menu-item-has-children').forEach(function (sibling) {
          if (sibling !== item) {
            sibling.classList.remove('is--opend');
            const sibSub = sibling.querySelector(':scope > .sr4-sub-sub-menu');
            if (sibSub) sibSub.style.display = 'none';
          }
        });

        // Toggle clicked level-2 item
        item.classList.toggle('is--opend', !isOpen);
        subSubMenu.style.display = isOpen ? 'none' : 'block';
      });
    });
  }

  initAccordion();

  // Re-init if nav is injected dynamically
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.querySelector &&
            node.querySelector('.sr4-menu-item-has-children')) {
          initAccordion();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

});
